import React from 'react'

const EditIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g stroke={color} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="m11.76 3.008.693.692a1.173 1.173 0 0 1 0 1.655L4.65 13.157a.587.587 0 0 1-.41.17H2.132v-2.106c0-.154.062-.301.17-.41l7.803-7.803a1.173 1.173 0 0 1 1.655 0zM8 13.328h5.866" />
      </g>
    </svg>
  )
}

export default EditIcon
